import { Link } from "react-router-dom";
import { Badge } from "@/components/wensity/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/wensity/card";
import { type ContentItem, contentPath, formatDate } from "@/data/site";

export function ContentCard({ item }: { item: ContentItem }) {
  return (
    <Link to={contentPath(item)} className="group block h-full">
      <Card className="h-full border-[var(--color-border)] bg-[rgba(20,24,22,0.72)] transition duration-300 group-hover:-translate-y-0.5 group-hover:border-[var(--color-primary-dim)]">
        <CardHeader className="gap-3">
          <div className="flex items-center justify-between gap-3 text-xs uppercase tracking-[0.14em] text-[var(--color-muted)]">
            <span>{item.kind}</span>
            <time dateTime={item.date}>{formatDate(item.date)}</time>
          </div>
          <CardTitle className="text-lg text-[var(--color-foreground)] group-hover:text-[var(--color-primary)]">
            {item.title}
          </CardTitle>
          <CardDescription className="text-[var(--color-muted)]">{item.description}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2">
            {item.tags.map((tag) => (
              <Badge key={tag} variant="neutral" className="border-[var(--color-border)] bg-white/5 text-[var(--color-muted)]">
                {tag}
              </Badge>
            ))}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
